<template>
  <div>
    <section class="xs-banner service-banner-2 contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 col-md-6 align-self-center">
            <div class="xs-banner-content">
              <div class="xs-banner-group">
                <h2 class="banner-title wow fadeInLeft" data-wow-duration="1s">DEDICATED HOSTING</h2>
                <p class="wow fadeInLeft" data-wow-duration="1.5s">Share processes and data securely on a need to know
                  basis without the need for reconciliation it combines a permissione.</p></div>
            </div>
          </div>
          <div class="col-lg-5 col-md-6 align-self-center">
            <div class="inner-welcome-image-group wow fadeIn">
              <img src="../assets/images/cloud-hosting-bg.png" data-parallax='{"y": 150}'
                   alt="hosting image">
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-1314" class="full-width-content post-1314 page type-page status-publish hentry">
          <div data-elementor-type="wp-post" data-elementor-id="1314"
               class="elementor elementor-1314 elementor-bc-flex-widget" data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-43e64b2 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="43e64b2" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-6d0aa37"
                        data-id="6d0aa37" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-6d4e4a7"
                        data-id="6d4e4a7" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-f357b22 elementor-widget elementor-widget-xs-heading"
                              data-id="f357b22" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Best Hosting</h3>
                                  <h2 class="heading-title">Why <span>CHOOSE US</span></h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-404c44d"
                        data-id="404c44d" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-acbd22e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="acbd22e" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-300d879 animated-slow animated fadeInUp"
                        data-id="300d879" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:0.7}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-6103974 elementor-widget elementor-widget-xs-image-box"
                              data-id="6103974" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-1.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">99.9% Uptime Guarantee</h4>
                                  <p>Share processes and data secure
                                    lona need to know basis</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-879e0ed animated-slow animated fadeInUp"
                        data-id="879e0ed" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:1.5}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-476bd1c elementor-widget elementor-widget-xs-image-box"
                              data-id="476bd1c" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-2.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Safe and Secured</h4>
                                  <p>Our team assured your web site is always safe and secure</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-b32f052 animated-slow animated fadeInUp"
                        data-id="b32f052" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:2}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-15a6ea4 elementor-widget elementor-widget-xs-image-box"
                              data-id="15a6ea4" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-3.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Our Dedicated Support</h4>
                                  <p>We finally found a host that truly understood the unique</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-ef46510 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="ef46510" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e7bcbeb"
                        data-id="e7bcbeb" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-ecd5d7a elementor-widget elementor-widget-xs-dedicated-perver-pricing"
                              data-id="ecd5d7a" data-element_type="widget"
                              data-widget_type="xs-dedicated-perver-pricing.default">
                              <div class="elementor-widget-container">
                                <div class="table-responsive">
                                  <table class="table table-striped server-price-table">
                                    <thead>
                                    <tr>
                                      <th scope="col">Intel Xeon Processor(s)</th>
                                      <th scope="col">MEMORY</th>
                                      <th scope="col">STORAGE</th>
                                      <th scope="col">TRANSFER</th>
                                      <th scope="col">MONTHLY</th>
                                      <th scope="col">DEPLOY</th>
                                      <th scope="col">AVAILABILITY</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span>E3-1230 v3 3.3GHz Haswell (4 cores +
                                        HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured ">CONFIGURE</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span>E3-1230 v3 3.3GHz Haswell (4 cores +
                                        HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured ">CONFIGURE</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span><span class="tag featured">new</span>E3-1230
                                        v3 3.3GHz Haswell (4 cores + HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured disabled">STOCK OUT</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span>E3-1230 v3 3.3GHz Haswell (4 cores +
                                        HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured ">CONFIGURE</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span>E3-1230 v3 3.3GHz Haswell (4 cores +
                                        HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured ">CONFIGURE</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span>E3-1230 v3 3.3GHz Haswell (4 cores +
                                        HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured ">CONFIGURE</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span><span class="tag featured">new</span>E3-1230
                                        v3 3.3GHz Haswell (4 cores + HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured disabled">STOCK OUT</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span>E3-1230 v3 3.3GHz Haswell (4 cores +
                                        HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured ">CONFIGURE</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span>E3-1230 v3 3.3GHz Haswell (4 cores +
                                        HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured ">CONFIGURE</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span>E3-1230 v3 3.3GHz Haswell (4 cores +
                                        HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured ">CONFIGURE</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span>E3-1230 v3 3.3GHz Haswell (4 cores +
                                        HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured ">CONFIGURE</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span><span class="tag featured">new</span>E3-1230
                                        v3 3.3GHz Haswell (4 cores + HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured disabled">STOCK OUT</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span>E3-1230 v3 3.3GHz Haswell (4 cores +
                                        HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured ">CONFIGURE</a></td>
                                    </tr>
                                    <tr>
                                      <th scope="row"><span class="tag">sale</span>E3-1230 v3 3.3GHz Haswell (4 cores +
                                        HT)
                                      </th>
                                      <td>16GB</td>
                                      <td>240GB SSD</td>
                                      <td>20TB</td>
                                      <td><span class="price"><del>$150.00</del> $135.00</span></td>
                                      <td>INSTANT</td>
                                      <td><a href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3"
                                             class="featured ">CONFIGURE</a></td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-349ae6d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="349ae6d" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2f0bc0e"
                        data-id="2f0bc0e" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-e45d773 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="e45d773" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-da92104"
                                    data-id="da92104" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-027f25a"
                                    data-id="027f25a" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-da653aa elementor-widget elementor-widget-xs-heading"
                                          data-id="da653aa" data-element_type="widget"
                                          data-widget_type="xs-heading.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-heading">
                                              <h3 class="heading-sub-title">We Offer</h3>
                                              <h2 class="heading-title">FEATURES INCLUDED</h2>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-3d834eb"
                                    data-id="3d834eb" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-8a4e168 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="8a4e168" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-de1d991"
                                    data-id="de1d991" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-c4aa1d1 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="c4aa1d1" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="49" height="68"
                                                                                           src="../assets/images/included-feature-1.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">No Multi Tenancy</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-b0c1a84 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="b0c1a84" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="52" height="67"
                                                                                           src="../assets/images/included-feature-2.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">LiteSpeed Web Server</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-13c2c0a elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="13c2c0a" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="50" height="45"
                                                                                           src="../assets/images/included-feature-3.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> cPanel Hosting Control</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-0d514d2"
                                    data-id="0d514d2" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-9e3788b elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="9e3788b" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="49" height="41"
                                                                                           src="../assets/images/included-feature-4.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">PHP Selector</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-0b76ecf elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="0b76ecf" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="52" height="53"
                                                                                           src="../assets/images/included-feature-5.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> LiteSpeed Web Server</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-8cc951c elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="8cc951c" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="47" height="55"
                                                                                           src="../assets/images/included-feature-6.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> Patchman Kiler</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-e20bf90 elementor-section-height-min-height elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
                  data-id="e20bf90" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-33170d8"
                        data-id="33170d8" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-35e70fc elementor-widget elementor-widget-xs-testimonial"
                              data-id="35e70fc" data-element_type="widget" data-widget_type="xs-testimonial.default">
                              <div class="elementor-widget-container">
                                <div class="xs-testimonial-slider owl-carousel owl-loaded owl-drag">

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transition: all 0s ease 0s; width: 3834px; transform: translate3d(-766px, 0px, 0px);">
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-4-55x55.jpg"
                                                  alt="avatar-4" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active center" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-3-55x55.png"
                                                  alt="avatar-3" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-4-55x55.jpg"
                                                  alt="avatar-4" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-3-55x55.png"
                                                  alt="avatar-3" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-1934763 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="1934763" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-32776e6"
                        data-id="32776e6" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-669a751 elementor-widget elementor-widget-xs-partner"
                              data-id="669a751" data-element_type="widget" data-widget_type="xs-partner.default">
                              <div class="elementor-widget-container">
                                <div class="xs-client-slider owl-carousel owl-loaded owl-drag">


                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transform: translate3d(-1120px, 0px, 0px); transition: all 0s ease 0s; width: 3360px;">
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-4a2b275 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="4a2b275" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-6e28d98"
                        data-id="6e28d98" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-0183dcb elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="0183dcb" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="122" height="138"
                                           src="../assets/images/sheild-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Days money back guarantee</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-216fc4d"
                        data-id="216fc4d" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-662a139 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="662a139" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="129" height="138"
                                           src="../assets/images/cloud-lock-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Build and protect your brand</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-69225f0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="69225f0" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9b36a"
                        data-id="ae9b36a" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-ee81f15 elementor-widget elementor-widget-spacer"
                              data-id="ee81f15" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'DedicatedHosting'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/DedicatedHosting.vue